// registry-client: ÚNICA fronteira com o back. O front depende do back só por HTTP — nunca por import de código.
// Dois caminhos:
//   loadCatalog(url)      -> baixa o CATÁLOGO RICO (JSON) e monta o CapabilityRegistry para o shell governado.
//   fetchCapabilities(url) -> consome a projeção fina GET /capabilities (contrato documentado do back).
import { CapabilityRegistry, type CapabilityCatalog } from "./capability.js";
import i18n from "./i18n.js";

type FetchFn = typeof fetch;

// Caminho RICO (renderização do shell): baixa o catálogo completo de uma URL.
// Default = asset bundlado (/capabilities.json) -> roda sem back. Override -> back real via env.
export async function loadCatalog(
  url: string,
  fetchFn: FetchFn = fetch,
): Promise<CapabilityRegistry> {
  const res = await fetchFn(url);
  if (!res.ok) {
    throw new Error(i18n.t("registryErrors.catalogUnavailable", { url, status: res.status }));
  }
  const catalog = (await res.json()) as CapabilityCatalog;
  return CapabilityRegistry.fromCatalog(catalog);
}

// Caminho FINO (contrato do back): consome GET /capabilities.
// Se falhar -> erro honesto (shell vazio), nunca inventa dados.
export async function fetchCapabilities(
  baseUrl: string,
  fetchFn: FetchFn = fetch,
): Promise<
  Array<{ capability_id: string; surface_owner: string; status: string; backend_ready: boolean }>
> {
  const res = await fetchFn(`${baseUrl}/capabilities`);
  if (!res.ok) {
    throw new Error(i18n.t("registryErrors.capabilitiesUnavailable", { status: res.status }));
  }
  return (await res.json()) as Array<{
    capability_id: string;
    surface_owner: string;
    status: string;
    backend_ready: boolean;
  }>;
}
